import { useNotifyOpenLayerObserver } from '@atlaskit/layering/experimental/open-layer-observer';
/**
 * Functional component wrapper around `useNotifyOpenLayerObserver`.
 *
 * This is needed as Select is a class component, which cannot use hooks directly.
 */
export function NotifyOpenLayerObserver(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose;
  // @ts-ignore - hot-116676
  useNotifyOpenLayerObserver({
    isOpen: isOpen,
    onClose: onClose
  });
  return null;
}